<template>
<div :style="bigChooseSmall"></div>
</template>

<script>
import { ref, computed } from 'vue';
export default {
    name: "bigChooseSmall1",
    setup(){
        const featureAreaCoordinates = ref([]);
        const adaptationMultiple=computed(()=>{
            return window.innerHeight*0.066+4
        })
        const carousel=ref();
        // 使用计算属性动态计算sonWidth、sonHeight和SFBS
        const sonWidth = computed(() => featureAreaCoordinates.value[2] - featureAreaCoordinates.value[0]);
        const widthScaleFacto=computed(()=> adaptationMultiple.value/sonWidth.value);
        const sonHeight = computed(() => featureAreaCoordinates.value[3] - featureAreaCoordinates.value[1]);
        const heightScaleFacto=computed(()=>adaptationMultiple.value/sonHeight.value);
        const SFBS = computed(() => sonWidth.value > sonHeight.value ? adaptationMultiple.value / sonWidth.value : adaptationMultiple.value / sonHeight.value);
        // if(featureAreaCoordinates.value){
        //     sonWidth.value=featureAreaCoordinates.value[2]-featureAreaCoordinates.value[0]
        //     sonHeight.value=featureAreaCoordinates.value[3]-featureAreaCoordinates.value[1]
        // }
        // SFBS.value=sonWidth.value > sonHeight.value ? 99.83 / sonWidth.value : 99.83 / sonHeight.value
        const bigChooseSmall = computed(() => {
            if (!featureAreaCoordinates.value.length) {
                return {};
            }
            return {
                width: (featureAreaCoordinates.value[2] - featureAreaCoordinates.value[0]) + 'px',
                height: (featureAreaCoordinates.value[3] - featureAreaCoordinates.value[1]) + 'px',
                backgroundImage: `url(${carousel.value})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: `-${featureAreaCoordinates.value[0]}px -${featureAreaCoordinates.value[1]}px`,
                transform: `scale(${widthScaleFacto.value},${heightScaleFacto.value})`,
                position: 'absolute', // 添加绝对定位
            };
        });
        return{
            bigChooseSmall,
            featureAreaCoordinates,
            sonWidth,
            sonHeight,
            SFBS,
            carousel,
            widthScaleFacto,
            heightScaleFacto,
            adaptationMultiple
        }
    }
}
</script>

<style scoped>

</style>